import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseDiscountManagment() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      type: isEmpty(state.type),
      filter: isEmpty(state.filter),
      categoryID: isEmpty(state.categoryID),
      groupID: isEmpty(state.groupID),
      brandID: isEmpty(state.brandID),
    };

    setter(errorState);

    if (errorState.type || errorState.filter) {
      enqueueSnackbar("لطفا محصول را کامل انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.filter == 2 && errorState.brandID) {
      enqueueSnackbar("لطفا برند را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.filter == 3 && errorState.groupID) {
      enqueueSnackbar("لطفا گروه را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getDiscountList = (bool, callback) => {
    MyAxios.get(`Admin_DiscountManagment `, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: {} }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  ////////////////////   direct        ////////////////////////////

  const getDirectDiscount = (myPC, search, callback) => {
    MyAxios.get(`Admin_DiscountManagment/Direct?w=${search}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getDirectCandidate = (myPC, callback) => {
    MyAxios.get(`Admin_DiscountManagment/Direct/Candidate`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addDirectDiscount = (state, callback) => {
    state = removeSomeProps(state);
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DiscountManagment/Direct`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("تخفیف مستقیم با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteDirectDiscount = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.delete(`Admin_DiscountManagment/Direct`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("تخفیف مستقیم با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  ////////////////////   batch        ////////////////////////////

  const getBatchDiscount = (isActiveBD, myPC, search, callback) => {
    MyAxios.get(
      `Admin_DiscountManagment/Batch?w=${search}&isActive=${isActiveBD}`,
      {
        headers: {
          Conditions: JSON.stringify({ pageCondition: myPC }),
        },
      }
    ).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getBatchCandidate = (myPC, callback) => {
    MyAxios.get(`Admin_DiscountManagment/Batch/Candidate`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addBatchDiscount = (state, callback) => {
    state = removeSomeProps(state);
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_DiscountManagment/Batch`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("تخفیف بچ با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteBatchDiscount = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.delete(`Admin_DiscountManagment/Batch`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("تخفیف بچ با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const removeSomeProps = (model) => {
    delete model.filter;
    if (model.brandID == undefined) {
      delete model.brandID;
    }
    if (model.categoryID == undefined) {
      delete model.categoryID;
    }
    if (model.groupID == undefined) {
      delete model.groupID;
    }
    if (model.type == undefined) {
      delete model.type;
    }
    if (model.productID == undefined) {
      delete model.productID;
    }
    if (model.discountCost == undefined) {
      delete model.discountCost;
    }
    if (model.productLimit == undefined || model.productLimit == "") {
      delete model.productLimit;
    }
    return model;
  };

  return {
    validate,
    getDiscountList,
    getDirectDiscount,
    getDirectCandidate,
    addDirectDiscount,
    deleteDirectDiscount,
    getBatchDiscount,
    getBatchCandidate,
    addBatchDiscount,
    deleteBatchDiscount,
  };
}
